



import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import realestateicon from '../../../../assets/askTheExpertImages/realestatemenuicon.svg';
import bannerrealbackmobile from '../../../../assets/images/bannerrealbackmobile.png';
import askimg from "../../../../assets/homeimages/askbtn.svg";
import './articleDetails.css';
import { decodeHtmlEntities } from "../../../../shared/helper";
import { useTranslation } from "react-i18next";
const RealestateArticleDetailsJsx = (props) => {
  const {
    detailsData
  } = props;
  const { t } = useTranslation();



  return (
    <>
      <section className="realestateblogdetails">
        <div className="container">
          <div className="blogsectioone">
            <div className="tagreal"><span><img src={realestateicon} alt="Realestate Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
            <div className="blogsectioleft">
              <div className="title">
                <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
              <p>{detailsData?.acf?.banner_sectionn.short_description}</p>
            </div>
            <div className="d-flex userdetails">
              <div className="userphoto">
                <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
              </div>
              <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
            </div>
          </div>

          <div className="blogsectiontwo">
            <h2>{detailsData?.acf?.info_block?.title}</h2>
            <div className="row">
              <div className="col">
                <div className="blogsectiontwoinner">
                  <div className="blogsectiontwoinnerspot">{detailsData?.acf?.info_block?.info_block_1?.title}</div>
                  <p>{detailsData?.acf?.info_block?.info_block_1?.description}</p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiontwoinner">
                  <div className="blogsectiontwoinnerspot">{detailsData?.acf?.info_block?.info_block_2?.title}</div>
                  <p>{detailsData?.acf?.info_block?.info_block_2?.description}</p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiontwoinner">
                  <div className="blogsectiontwoinnerspot">{detailsData?.acf?.info_block?.info_block_3?.title}</div>
                  <p>{detailsData?.acf?.info_block?.info_block_3?.description}</p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiontwoinner">
                  <div className="blogsectiontwoinnerspot">{detailsData?.acf?.info_block?.info_block_4?.title}</div>
                  <p>{detailsData?.acf?.info_block?.info_block_4?.description}</p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiontwoinner">
                  <div className="blogsectiontwoinnerspot">{detailsData?.acf?.info_block?.info_block_5?.title}</div>
                  <p>{detailsData?.acf?.info_block?.info_block_5?.description}</p>
                </div>
              </div>
            </div>
          </div>


          <div className="blogsectionthree">
            <h2>{detailsData?.acf?.definition_block?.title}</h2>
            <div className="row">
              <div className="col-lg-6 col-sm-6">
                <div className="blogsectionthreeinne" style={{ background: `url(${detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_1?.image})` }}>
                  <p>{detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_1?.desciption}</p>
                </div>
              </div>
              <div className="col-lg-6 col-sm-6">
                <div className="blogsectionthreeinne" style={{ background: `url(${detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_2?.image})` }}>
                  <p>{detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_2?.desciption}</p>
                </div>
              </div>
            </div>
          </div>


          <div className="blogsectionfour">
            <h2>{detailsData?.acf?.statistical_overview?.title}</h2>
            <div className="blogsectionfourinner">
              <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                    <div className="row">
                      <div className="col-lg-4 col-sm-4">
                        <div className="blogsectionfourimage"><img src={detailsData?.acf?.statistical_overview?.info_block_1?.image} alt="blogimage" /></div>
                      </div>
                      <div className="col-lg-8 col-sm-8">
                        <div className="blogsectionfourtext">
                          <h4>{detailsData?.acf?.statistical_overview?.info_block_1?.title}</h4>
                          <p>{detailsData?.acf?.statistical_overview?.info_block_1?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                    <div className="row">
                      <div className="col-lg-4 col-sm-4">
                        <div className="blogsectionfourimage"><img src={detailsData?.acf?.statistical_overview?.info_block_2?.image} alt="blogimage" /></div>
                      </div>
                      <div className="col-lg-8 col-sm-8">
                        <div className="blogsectionfourtext">
                          <h4>{detailsData?.acf?.statistical_overview?.info_block_2?.title}</h4>
                          <p>{detailsData?.acf?.statistical_overview?.info_block_2?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                    <div className="row">
                      <div className="col-lg-4 col-sm-4">
                        <div className="blogsectionfourimage"><img src={detailsData?.acf?.statistical_overview?.info_block_3?.image} alt="blogimage" /></div>
                      </div>
                      <div className="col-lg-8 col-sm-8">
                        <div className="blogsectionfourtext">
                          <h4>{detailsData?.acf?.statistical_overview?.info_block_3?.title}</h4>
                          <p>{detailsData?.acf?.statistical_overview?.info_block_3?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                    <div className="row">
                      <div className="col-lg-4 col-sm-4">
                        <div className="blogsectionfourimage"><img src={detailsData?.acf?.statistical_overview?.info_block_4?.image} alt="blogimage" /></div>
                      </div>
                      <div className="col-lg-8 col-sm-8">
                        <div className="blogsectionfourtext">
                          <h4>{detailsData?.acf?.statistical_overview?.info_block_4?.title}</h4>
                          <p>{detailsData?.acf?.statistical_overview?.info_block_4?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="blogsectiofive">
            <div className="blogsectiofiveinner">
              <div className="d-block d-lg-none d-sm-none d-md-none blogsectiofiveinnerimage">
                <img src={bannerrealbackmobile} alt="realestateimage" />
              </div>
              <div className="blogsectiofiveinnerts">
                <h4>{detailsData?.acf?.overlay_section?.title}</h4>
                <p>{detailsData?.acf?.overlay_section?.description}</p>
                <Link to={'/AskTheExpert'}>
                            <div className={`askbutton`}>
                                <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                                <img src={askimg} alt="Ask now" />
                            </div>
                        </Link> 
              </div>
            </div>
          </div>


          <div className="blogsectionsix">
            <div className="row">
              <div className="col-lg-4 col-sm-4">
                <div className="blogsectionfourimage"><img src={detailsData?.acf?.maintaining_section?.image} alt="blogimage" /></div>
              </div>
              <div className="col-lg-8 col-sm-8">
                <div className="blogsectionfourtext">
                  <h4>{detailsData?.acf?.maintaining_section?.title}</h4>
                  <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.maintaining_section?.description }}>

                  </div>

                </div>
              </div>
            </div>
          </div>


          <div className="blogsectionseven">
            <div className="row">
              <div className="col-lg-8 col-sm-8">
                <div className="blogsectionsevenext">
                  <h4>{detailsData?.acf?.conclusion_section?.title}</h4>
                  <p>
                    {detailsData?.acf?.conclusion_section?.description}
                  </p>

                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="blogsectionsevenimage"><img src={detailsData?.acf?.conclusion_section?.image} alt="blogimage" /></div>
              </div>

            </div>

          </div>

        </div>
      </section>

     
    </>

  );
};

export default RealestateArticleDetailsJsx;